import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

export interface Company {
  id: number
  fantasy_name: string
  name: string
  cnpj: string
  logo: string
  telephone: string
  email: string
  instagram: string
  site: string
  country: string
  city: string
  state: string
  cep: string
  address: string
  neighborhood: string
  number: string
  createdAt: string
  updatedAt: string
}

interface CompanyState {
  company: Company | null
  setCompany: (data: Company) => void
  clearCompany: () => void
}

export const useCompanyStore = create(
  persist<CompanyState>(
    (set) => ({
      company: null,
      setCompany: (data) => set({ company: data }),
      clearCompany: () => set({ company: null }),
    }),
    {
      name: "company-storage", // Nome da chave no localStorage
      storage: createJSONStorage(() => localStorage),
    },
  ),
)